import {
  GET_LIST_DANHSACHDONDATHANG,
  GET_LIST_DANHSACHDONDATHANG_SUCCESS,
  GET_LIST_DANHSACHDONDATHANG_FAILURE,
  UPDATE_SEARCHTDATA_DANHSACHDONDATHANG,
  UPDATE_DANHSACHDONDATHANG,
  UPDATE_SEARCHTDATA_INNHANHDANHSACHDONDATHANG,
} from "./actionTypes";

export const getListDanhSachDonDatHang = (dataSearch) => ({
  type: GET_LIST_DANHSACHDONDATHANG,
  dataSearch,
});
export const getListDanhSachDonDatHangSuccess = (data) => ({
  type: GET_LIST_DANHSACHDONDATHANG_SUCCESS,
  payload: data,
});
export const getListDanhSachDonDatHangFailure = (dataSearch) => ({
  type: GET_LIST_DANHSACHDONDATHANG_FAILURE,
});
export const updateDataSearch = (data) => ({
  type: UPDATE_SEARCHTDATA_DANHSACHDONDATHANG,
  payload: data,
});

export const updateListDanhSachDonDatHang = (data) => ({
  type: UPDATE_DANHSACHDONDATHANG,
  payload: data,
});

export const updateInNhanhDanhSachDonDatHang = (data) => ({
  type: UPDATE_SEARCHTDATA_INNHANHDANHSACHDONDATHANG,
  payload: data,
});
